export default "__VITE_ASSET__0bbd69cd__"